



































// vue
import { defineComponent, onMounted, ref } from '@vue/composition-api';
import { useStore } from '@/store';

// primevue
import Button from 'primevue/button';
import EditorDropdown from '@/vue3/components/editor/EditorDropdown.vue';

// hooks
import { useNotify } from '@/vue3/hooks/notifyHook';

// service
import { useService } from '../api/services';

export default defineComponent({
    components: {
        Button,
        EditorDropdown,
    },
    setup() {
        // hooks
        const { successToast, warnToast } = useNotify();

        // services
        const {
            getBuggyTrackerDetails,
            createorUpdateBuggytrackerDetails,
            deleteBuggyTrackerDetails,
        } = useService();

        // ref
        const buggySiteId = ref<string>('');
        const buggyFrequency = ref<any>();
        const siteIdSelector = ref();
        const frequencySelector = ref();

        // configs
        const siteIds = [{ id: 1664618159 }];

        const frequencies = [
            { id: 4, name: '30 sec', secs: 30 },
            { id: 5, name: '1 min', secs: 60 },
            { id: 6, name: '2 min', secs: 120 },
            { id: 7, name: '3 min', secs: 180 },
            { id: 8, name: '5 min', secs: 300 },
            { id: 9, name: '10 min', secs: 6000 },
        ];

        // methods
        const applyBuggyTackerData = async (): Promise<void> => {
            buggySiteId.value = siteIdSelector.value.id;
            buggyFrequency.value = frequencySelector.value.secs;
            if (buggySiteId.value == '' || buggyFrequency.value == '') {
                warnToast(`Please enter correct Buggy Tracker Data.`);
            }
            await createorUpdateBuggytrackerDetails(
                buggySiteId.value,
                buggyFrequency.value,
            );

            successToast(`Buggy Tracker Data successfully added. `);
        };

        const initBuddyData = async (): Promise<void> => {
            let buggydetails = await getBuggyTrackerDetails();
            siteIdSelector.value = siteIds.find(
                (siteArr) => '' + siteArr.id == buggydetails.site_id,
            );
            frequencySelector.value = frequencies.find(
                (frequencyArr) =>
                    '' + frequencyArr.secs == buggydetails.frequency,
            );
        };

        const clearBuggyTracker = async (): Promise<void> => {
            buggySiteId.value = '';
            buggyFrequency.value = '';
            siteIdSelector.value = {};
            frequencySelector.value = {};

            await deleteBuggyTrackerDetails();
            successToast(`Buggy Tracker Data successfully cleared. `);
        };

        // lifycycle
        onMounted(() => {
            initBuddyData();
        });

        return {
            siteIds,
            frequencies,
            siteIdSelector,
            frequencySelector,
            applyBuggyTackerData,
            clearBuggyTracker,
        };
    },
});
